import { cn } from '@/lib/utils';

/**
 * Gradinitele nu se pot inscrie — cerut de ECOTIC pe 09.10. Backendul refuza deja unitatile care
 * nu sunt scoli (`SelectieMec`), dar dupa DENUMIRE: o educatoare de la o gradinita arondata unei
 * scoli alege scoala, care e eligibila, si trece. Lista MEC nu separa structurile arondate, deci
 * aici nu avem ce bloca — doar ce spune, inainte ca omul sa completeze formularul.
 *
 * O singura componenta pentru toate locurile, ca textul sa nu divergeze la prima corectie.
 */
export function NotaGradinite({ className }: { className?: string }) {
  return (
    <p className={cn('m-0 text-fluid-sm text-muted-foreground', className)}>
      Grădinițele nu pot fi înscrise în Școala Ecoterrienilor. Pentru preșcolari recomandăm
      înscrierea în „Și cei mici fac fapte mari”.
    </p>
  );
}
